import React from "react";
import Base from "../Base";
import CustomerTable from "../../components/CustomerPageComponents/CustomerTable";

const Customer = () => {
  return (
    <Base>
      <CustomerTable />
    </Base>
  );
};

export default Customer;
